import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { EditableType } from '../../../../containers/Editor/constants';
import { Label, LabelItem, Button } from './styles';

interface EditPanelLabelProps {
	type: EditableType;
	availableTypes: EditableType[];
	onClick: (type: EditableType) => void;
}

const panelTypes = [
	EditableType.text,
	EditableType.image,
	EditableType.video,
	EditableType.link,
];

const EditPanelLabel = ({ type, availableTypes, onClick }: EditPanelLabelProps) => (
	<Label>
		{panelTypes.map((panelType: EditableType) => {
			const isActive = panelType === type;
			const isDisabled = isActive || !availableTypes.includes(panelType);
			return (
				<LabelItem key={panelType}>
					<Button
						type="button"
						isActive={isActive}
						disabled={isDisabled}
						onClick={() => onClick(panelType)}
					>
						<Translate value={`messages.${panelType}`} />
					</Button>
				</LabelItem>
			);
		})}
	</Label>
);

export default EditPanelLabel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Label/index.tsx